import request from 'api/request';

export default function resetPasswordRoute({ token, password }) {
  return request({
    url: '/passwords/reset',
    method: 'POST',
    data: { token, password },
  });
}
